var url = $.url(document.location);

/* FIX TO OVERCOME VERTICAL SCROLL ISSUE */
if (parseInt($('body').css('height')) < 1300)
{
	var page = url.data.seg.path[1];
	//krunal 13-10-2015
	/*if (page == 'about-us' || url.data.seg.path.length == 1)
		$('.main-content').css('height', '1100px'); 
	else
		$('.main-content').css('height', '1300px');*/
} 


/* REMOVE NAV WHEN ON DESKTOP/MOBILE */
if ($(document).width() < 768)
	$('.nav-remove-on-mobile').remove();
else
	$('.nav-remove-on-desktop').remove();

/* BLOG SEARCH */

if (url.data.seg.path[0] == 'search')
{
	var res = document.location.href.split("=");

  	if (res[2])
    {
      // when doing a blog search only want to show articles that are within that blog
      if (res[2].indexOf('blog') != 0)
      {
          $('ul.list-blog').hide();

          var blog = res[3].replace('+','-');
              blog = blog.replace('+','-');

          $('.article-description').each(function() 
          {
              //console.log($(this).find('a').attr('href'));
              //console.log($(this).find('a').attr('href').indexOf(blog));

              if ($(this).find('a').attr('href').indexOf(blog) == -1)
              {
                  $(this).parent().parent().parent().remove();
              }
          });

          $('ul.list-blog').show();
      } 
    }
}

/* SET ARTICLE HERO IMAGE HEIGHT */
if ($(document).width() > 768)
{
	if (url.data.seg.path[0] == 'blogs')
	{
		var counter = 0;
		$('.blog-detail .rte img').each(function(){

		if (counter == 0)
		    $(this).addClass('hero');

		counter ++;

		});
	}
}

/* NAV SET ACTIVE IF COLLECTION */
if (url.data.seg.path[0] == 'collections')
	$('.nav-bar .site-nav li.dropdown').addClass('current');

/* CREATE LINK ON PRODUCT PAGE TO ARTICLE */
if (url.data.seg.path[0] == 'products') {
	$('#product-tags span').each(function() {
	    if ($.isNumeric( $(this).text() ))
	    {
	        var article_id = $(this).text();
	        $('#articles span').each(function() {
	              if ($(this).attr('id') == article_id)
	              {
	                  var coll = $(this).attr('data-coll');
	                  var url = $(this).attr('data-url');
	                  $('#product-article-link').html('<div style="margin-bottom:15px; text-decoration: underline"><a href="'+url+'">'+$(this).text()+'</a></div>');
	              }
	        });
	    }
	});
}

/* MOBILE SIDE NAV - SHOW/HIDE FILTER */
$(".left-nav-filter").click(function() {
	if (!$('.filter-container').is(":visible"))
    	$('.filter-container').slideDown("fast");
    else
    	$('.filter-container').slideUp("fast");
});

/* LEFT NAV BRANDS
$('.widget-container-brands').on('hover', function() {
	if (!$(this).find('.widget-content').is(":visible"))
    	$(this).find('.widget-content').slideDown("fast");
    else
    	$(this).find('.widget-content').slideUp("fast");
}); */
if (!("ontouchstart" in document)) {
    $(".widget-container-brands").hover(function() {
        if (!$(this).find('.widget-content').is(":visible")) {
	    	$(this).find('.widget-content').slideDown("fast");
        }
    });
    $(".widget-container-brands").mouseleave(function() {
        $(this).find('.widget-content').slideUp("fast")
    });
} else {
   	$(".widget-container-brands").click(function() {
        if ($(this).find('.widget-content').is(":visible")) {
            $(this).find('.widget-content').slideUp("fast")
        } else {
            $(this).find('.widget-content').slideDown("fast")
        }
    });
}

/* TOP SUB NAV FOR NEW PRODUCTS
$('.customer-link-whats-new li:nth-child(2)').on('hover', function() {
	if (!$('#whats-new-sub-menu').is(":visible"))
    	$('#whats-new-sub-menu').slideDown("fast");
    else
    	$('#whats-new-sub-menu').slideUp("fast");
}); */

if (!("ontouchstart" in document)) {
    $(".customer-link-whats-new li:first-child").hover(function() {
        if (!$(".site-nav-whats-new-sub").is(":visible")) {         
            $(".site-nav-whats-new-sub").slideDown("fast")
        }
    });
    $(".site-nav-whats-new-sub").mouseleave(function() {
        $(".site-nav-whats-new-sub").slideUp("fast");
    });
} else {
   	$(".customer-link-whats-new li:first-child").click(function() {
        if ($(".site-nav-whats-new-sub").is(":visible")) {
            $(".site-nav-whats-new-sub").slideUp("fast")
        } else {
            $(".site-nav-whats-new-sub").slideDown("fast")
        }
    });
}

/* SET VIEWPORT FOR MOBILE */
/*<meta name="viewport" content="initial-scale=1.0001, minimum-scale=1.0001"/>*/

/*if (screen.width <= 480) {
	viewport = document.querySelector("meta[name=viewport]");
	viewport.setAttribute('content', 'initial-scale=1.0001, minimum-scale=1.0001');

	console.log(viewport);
}*/


/* OVERRIDE HREF ON DEVICES */
if (("ontouchstart" in document)) {
	// WHATS NEW MAIN TITLE DROPDOWN
	$('.customer-link-whats-new li:first-child a').attr('href', '#');

}

/* move the header below the image or excerpt */
if ($('body').hasClass('template-article')) {
	/*if ('.blog-inner-detail .rte h6.excerpt')
		$('.page-header').appendTo('.blog-inner-detail .rte h6');
	else
		$('.page-header').appendTo('.blog-inner-detail .rte p:first-child');*/
	
	//$('.page-header').prependTo('.blog-inner-detail .rte .excerpt a:nth-child(2)');

	$('.page-header').prependTo('.blog-inner-detail .rte p:nth-child(3)');

	// adjust height of first image
	$('.rte img:first_child').css('height','450px');
}

/* remove the description image */
if ($('body').hasClass('template-blog'))
	$('.article-description img').remove();

if ($('body').hasClass('template-article'))
{
	 if ($('div').children().hasClass('blog-inner-detail'))
	 {
	 	$(".products").append( $('.product-list').remove() );
	 	$(".product-list").css('margin-bottom','0px');
	 	$(".blog-detail .user-tags").css('padding-bottom','0px');

	 	// move the excerpt
	 	//$('.rte p:first-child()').append( '<p class="excerpt">'+$('.excerpt').text()+'</p>' );
	 }
}


$(".newsletter-dropdown").hide();
/*$(".my-dropdown-cart").hide();*/
$(".account-nav-dropdown").hide();
$(".selectize-dropdown").hide();

$(".icon-search").on("click",function() {
 
  	if ($(".my-dropdown-search").is(":visible")) {
    	$(".my-dropdown-search").hide(); 
     }else{
    	$(".account-nav-dropdown").hide(); 
 		$(".newsletter-dropdown").hide();
		$(".my-dropdown-cart").hide();
    	$(".my-dropdown-search").show();
     }
  
});

$("#icon-account").on("click",function() {
       
  	 if ($(".account-nav-dropdown").is(":visible")) {
    	$(".account-nav-dropdown").hide(); 
     }else{
    	$(".account-nav-dropdown").show(); 
 		$(".newsletter-dropdown").hide();
		$(".my-dropdown-cart").hide();
    	$(".my-dropdown-search").hide();
     }
});

$(".icon-newsletter").on("click",function() {
       
  	 if ($(".newsletter-dropdown").is(":visible")) {
    	$(".newsletter-dropdown").hide(); 
     }else{
    	$(".account-nav-dropdown").hide(); 
 		$(".newsletter-dropdown").show();
		$(".my-dropdown-cart").hide();
    	$(".my-dropdown-search").hide();
     }
});


if (!("ontouchstart" in document)) {
    $(".icon-cart").hover(function() {
        $(".newsletter-dropdown").hide();
    	$(".my-dropdown-search").hide();
		$(".account-nav-dropdown").hide();
		$(".selectize-dropdown").hide();

        if (!$(".my-dropdown-cart").is(":visible")) {
            $(".my-dropdown-cart").slideDown("fast")
        }
    });
    $(".my-dropdown-cart").mouseleave(function() {
        $(".my-dropdown-cart").slideUp("fast")
    });
} else {
   	$(".icon-cart").click(function(e) {
        $(".newsletter-dropdown").hide();
   		$(".my-dropdown-search").hide();
		$(".account-nav-dropdown").hide();
		$(".selectize-dropdown").hide();

        if ($(".my-dropdown-cart").is(":visible")) {
            $(".my-dropdown-cart").slideUp("fast");
        } else {
            $(".my-dropdown-cart").slideDown("fast");
            e.stopPropagation();
        }
    });
}

/*
if (!("ontouchstart" in document)) {
    $(".icon-search").hover(function() {
        $(".newsletter-dropdown").hide();
    	$(".my-dropdown-cart").hide();
		$(".account-nav-dropdown").hide();
		$(".selectize-dropdown").hide();
		
        if (!$(".my-dropdown-search").is(":visible")) {
            $(".my-dropdown-search").slideDown("fast")
        }
    });
    $(".my-dropdown-cart").mouseleave(function() {
        $(".my-dropdown-cart").slideUp("fast")
    });
} else {
   	$(".icon-search").click(function() {
        $(".newsletter-dropdown").hide();
   		$(".my-dropdown-cart").hide();
		$(".account-nav-dropdown").hide();
		$(".selectize-dropdown").hide();

        if ($(".my-dropdown-search").is(":visible")) {
            $(".my-dropdown-search").slideUp("fast")
        } else {
            $(".my-dropdown-search").slideDown("fast")
        }
    });
}

if (!("ontouchstart" in document)) {
    $(".icon-cart").hover(function() {
        $(".newsletter-dropdown").hide();
    	$(".my-dropdown-search").hide();
		$(".account-nav-dropdown").hide();
		$(".selectize-dropdown").hide();

        if (!$(".my-dropdown-cart").is(":visible")) {
            $(".my-dropdown-cart").slideDown("fast")
        }
    });
    $(".my-dropdown-cart").mouseleave(function() {
        $(".my-dropdown-cart").slideUp("fast")
    });
} else {
   	$(".icon-cart").click(function(e) {
        $(".newsletter-dropdown").hide();
   		$(".my-dropdown-search").hide();
		$(".account-nav-dropdown").hide();
		$(".selectize-dropdown").hide();

        if ($(".my-dropdown-cart").is(":visible")) {
            $(".my-dropdown-cart").slideUp("fast");
        } else {
            $(".my-dropdown-cart").slideDown("fast");
            e.stopPropagation();
        }
    });
}

if (!("ontouchstart" in document)) {
    $("#icon-account").hover(function() {
        $(".newsletter-dropdown").hide();
    	$(".my-dropdown-search").hide();
		$(".my-dropdown-cart").hide();
		$(".selectize-dropdown").hide();

        if (!$(".account-nav-dropdown").is(":visible")) {
            $(".account-nav-dropdown").slideDown("fast")
        }
    });
    $(".account-nav-dropdown").mouseleave(function() {
        $(".account-nav-dropdown").slideUp("fast")
    });
} else {
   	$("#icon-account").click(function() {
        $(".newsletter-dropdown").hide();
   		$(".my-dropdown-search").hide();
		$(".my-dropdown-cart").hide();
		$(".selectize-dropdown").hide();

        if ($(".account-nav-dropdown").is(":visible")) {
            $(".account-nav-dropdown").slideUp("fast")
        } else {
            $(".account-nav-dropdown").slideDown("fast")
        }
    });
}


if (!("ontouchstart" in document)) {
    $(".icon-newsletter").hover(function() {
    	$(".my-dropdown-search").hide();
		$(".my-dropdown-cart").hide();
		$(".account-nav-dropdown").hide();
        $(".selectize-dropdown").hide();

        if (!$(".newsletter-dropdown").is(":visible")) {
            $(".newsletter-dropdown").slideDown("fast")
        }
    });
    $(".newsletter-dropdown").mouseleave(function() {
        $(".newsletter-dropdown").slideUp("fast")
    });
} else {
	$(".my-dropdown-search").hide();
	$(".my-dropdown-cart").hide();
	$(".account-nav-dropdown").hide();
    $(".selectize-dropdown").hide();

   	$(".icon-newsletter").click(function() {
      
        if ($(".newsletter-dropdown").is(":visible")) {
            $(".newsletter-dropdown").slideUp("fast")
        } else {
            $(".newsletter-dropdown").slideDown("fast")
        }
    });
}
*/
